import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { gaPageView } from "../utils/ga";

/**
 * Envía page views a Google Analytics cuando el usuario navega (SPA).
 */
const GATracker = () => {
  const location = useLocation();
  const prevPathRef = useRef(null);

  useEffect(() => {
    const path = location.pathname;
    if (path !== prevPathRef.current) {
      prevPathRef.current = path;
      gaPageView(path);
    }
  }, [location.pathname]);

  return null;
};

export default GATracker;
